module.exports = __webpack_public_path__ + "static/media/landing-background-without-watermark.2135edf5.jpg";